import { render } from "./ModuleFacetGroup.vue?vue&type=template&id=6575d8e2&scoped=true"
import script from "./ModuleFacetGroup.vue?vue&type=script&lang=js"
export * from "./ModuleFacetGroup.vue?vue&type=script&lang=js"

import "./ModuleFacetGroup.vue?vue&type=style&index=0&id=6575d8e2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6575d8e2"]])

export default __exports__